import { Form } from "antd";
import { BaseModalRef } from "components/BaseModal";
import message from "components/CustomMessage";
import { FindingBucketContextType } from "contexts/FindingBucketContext";
import React, { forwardRef } from "react";
import FindingAPI from "restAPI/FindingAPI";
import { FieldTypes } from "utils/formUtils";

import BulkUpdatePopup from "./BulkUpdatePopup";

type Props = {
  afterClose: () => void;
  bucket: FindingBucketContextType;
};

const CorrelateFindingsPopup = forwardRef<BaseModalRef, Props>(
  ({ afterClose, bucket }, ref) => {
    const [form] = Form.useForm();
    const totalFindingsCount = bucket.totalCount;

    const handleOnOk = async (data: any) => {
      await bucket.submit(data, FindingAPI.bulk.correlateFindings);

      message.success(
        "Correlate finding request accepted. Please check after some time.",
      );
    };

    const fields = [
      {
        value: (
          <span className="text-bold">
            Are you sure you want to correlate {totalFindingsCount} findings?
          </span>
        ),
        type: FieldTypes.LABEL,
      },
      {
        name: "correlationName",
        label: "Remediation Group",
        type: FieldTypes.TEXT_AREA,
        customLengthRule: {
          max: 1000,
          message: "Maximum length is 1000 characters",
        },
        required: true,
      },
      {
        name: "remediationAction",
        label: "Remediation Action",
        type: FieldTypes.TEXT_AREA,
        customLengthRule: {
          max: 1000,
          message: "Maximum length is 1000 characters",
        },
        required: true,
      },
    ];

    const modalProps = {
      okText: `Correlate ${totalFindingsCount} findings`,
    };

    return (
      <BulkUpdatePopup
        ref={ref}
        title={"Correlate findings"}
        form={form}
        onOk={handleOnOk}
        bucket={bucket}
        fields={fields}
        modalProps={modalProps}
        afterClose={afterClose}
      />
    );
  },
);

export default CorrelateFindingsPopup;
